export default __webpack_public_path__ + "static/media/icon-image.a548a98a.svg";